<div>
  <div class="uw-modal-header">
    <div class="heading-container">
      <span class="heading2">{{campaignService.campaignData.info.campaignName}}</span>
    </div>
    <div>
      <button [title]="'common.close' | translate" attr.aria-label="{{'aria.close_donation_opt_out_modal' | translate}}" (click)="onCancel()" mat-icon-button>
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
  <div class="uw-modal-content scroll-div" [formGroup]="optOutFormGroup">
    <div [innerHtml]="optOutMessage ? (optOutMessage | safeHtml ): '' ">
      <!-- <p>Sorry to see you go.</p>
      <p>We hope you will consider a future gift to United Way.</p>
      <p>
        Click ‘submit’ to opt out of our 2021 campaign. You will not receive
        further communication through the UnitedWay@work system this year. If you
        wish, select a reason below or click ‘Other’ to add comments or share
        ideas of how we can serve you better.
      </p>
      <p>
        This feedback is confidential and will not be shared with your workplace.
      </p> -->
    </div>

    <div class="row">
      <div class="col-sm-12 form-group">
        <select formControlName="reason" id="reason"
          [attr.aria-label]="'aria.opt_out_reason'| translate"
          (change)="onReasonChange($event)"
          [ngClass]="{'is-invalid': utils.fieldErrorCondition(this.optOutFormGroup.controls.reason) }">
          <option value="">{{'common.select' | translate}}</option>
          @for (reason of optOutReasonsList$ | async; track reason) {
            <option [value]="reason.key">{{reason.value}}</option>
          }
        </select>
      </div>
    </div>
    @if (!optOutFormGroup.controls.comments?.disabled) {
      <div class="row">
        <div class="col-sm-12 form-group">
          <textarea formControlName="comments" placeholder="Comments" rows="4"></textarea>
          <app-field-error-display [displayError]="isFieldValid('comments')"  errorMsg="welcome_page.error.missing_comments"></app-field-error-display>
        </div>
      </div>
    }
  </div>
  <div class="un-modal-footer align-right">
    <button [title]="'button.cancel' | translate" mat-button (click)="onCancel()">
      {{ "button.cancel" | translate }}
    </button>
    <uw-button [loading]="buttonLoading" [isMediumSize]="true" [gtmClass]="'uw-opt-out-selected'"
      (buttonClick)="onSave()" btnLabel="{{ 'button.update' | translate }}">
    </uw-button>
  </div>

</div>
